import CartDiscountsListPopoverForm from "@/app/components/cart/CartDiscountsListPopoverForm.vue";
import { VueContentPopover } from "@/app/popover/VueContentPopover";

export class CartDiscountsListPopover extends VueContentPopover {
    constructor(onDiscountRemoved: () => void) {
        super({ popoverClass: "cart-discounts-list-popover", fullscreen: false, flexHeight: true, condensed: true });

        const props = {
            onClose: () => this.hide(),
            onDiscountRemoved: onDiscountRemoved,
        };
        this.initComponent(CartDiscountsListPopoverForm, props);
    }
}
